import styled from '@emotion/styled'
export const StyleDateCard = styled.div`
  background: ${(props: any) => props.theme.colors.primary200};
  border-radius: 8px;
  height: 40px;
  padding: 0px 10px;
  display: flex;

  justify-content: space-between;
  column-gap: 10px;
  @media (max-width: 767px) {
    width: 100%;
  }
`
